// import node module libraries
import React, { useEffect, useState } from 'react';
import { Card, Carousel, Col, Dropdown, Image, Row } from 'react-bootstrap';

import { Link } from 'react-router-dom';

// import custom components
import ApexCharts from 'components/elements/charts/ApexCharts';
import StatRightIcon from 'components/dashboard/common/stats/StatRightIcon';

// import slides
import Slide1 from 'assets/images/ffem_slides/slide_1.jpg';
import Slide2 from 'assets/images/ffem_slides/slide_2.jpg';
import Slide3 from 'assets/images/ffem_slides/slide_3.jpg';
import Slide4 from 'assets/images/ffem_slides/slide_4.jpg';
import Slide5 from 'assets/images/ffem_slides/slide_5.jpg';
import Slide6 from 'assets/images/ffem_slides/slide_6.jpg';
import Slide7 from 'assets/images/ffem_slides/slide_7.jpg';
import Slide8 from 'assets/images/ffem_slides/slide_8.jpg';

// import data files
import {
	EarningsChartOptions,
	EarningsChartSeries,
	TrafficChartOptions,
	TrafficChartSeries
} from 'data/charts/ChartData';
import EleveService from '../services/EleveService';
import PersonnelService from '../services/PersonnelService';
import MatiereService from '../services/MatiereService';
import CompetenceService from '../services/CompetenceService';

// The forwardRef is important!!
// Dropdown needs access to the DOM node in order to position the Menu
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
	<Link
		to=""
		ref={ref}
		onClick={(e) => {
			e.preventDefault();
			onClick(e);
		}}
		className="btn-icon btn btn-ghost btn-sm rounded-circle"
	>
		{children}
	</Link>
));

const ChartActionMenu = () => {
	return (
		<div>
			<Dropdown>
				<Dropdown.Toggle as={CustomToggle}>
					<i className="fe fe-more-vertical text-muted"></i>
				</Dropdown.Toggle>
				<Dropdown.Menu align="end">
					<Dropdown.Header>SETTINGS</Dropdown.Header>
					<Dropdown.Item eventKey="1">
						<i className="fe fe-external-link dropdown-item-icon "></i> Export
					</Dropdown.Item>
					<Dropdown.Item eventKey="2">
						<i className="fe fe-mail dropdown-item-icon "></i> Email Report
					</Dropdown.Item>
					<Dropdown.Item eventKey="3">
						<i className="fe fe-download dropdown-item-icon "></i> Download
					</Dropdown.Item>
				</Dropdown.Menu>
			</Dropdown>
		</div>
	);
};

const Overview = () => {
	const [students, setStudents] = useState([]);
	const [personnels, setPersonnels] = useState([]);
	const [matieres, setMatieres] = useState([]);
	const [competences, setCompetences] = useState([]);

	useEffect(() => {
		EleveService.getAllEleves().then((response) => {
			setStudents(response);
		});
	}, []);

	useEffect(() => {
		PersonnelService.getAllActivePersonnels().then((response) => {
			setPersonnels(response);
		});
	}, []);

	useEffect(() => {
		MatiereService.getAllMatieres().then((response) => {
			setMatieres(response);
		});
	}, []);

	useEffect(() => {
		CompetenceService.getAllCompetences().then((response) => {
			setCompetences(response);
		});
	}, []);

	return (
		<div>
			<Row>
				<Col lg={12} md={12} sm={12}>
					<div className="border-bottom pb-4 mb-4 d-lg-flex justify-content-between align-items-center">
						<div className="mb-3 mb-lg-0">
							<h1 className="mb-0 h2 fw-bold">Dashboard</h1>
						</div>
					</div>
				</Col>
			</Row>

			<Row className="border-bottom pb-4 mb-4 d-lg-flex justify-content-between align-items-center">
				<Carousel indicators>
					<Carousel.Item>
						<Image className="d-block w-100" src={Slide1} alt="Slide 1" />
					</Carousel.Item>
					<Carousel.Item>
						<Image className="d-block w-100" src={Slide2} alt="Slide 2" />
					</Carousel.Item>
					<Carousel.Item>
						<Image className="d-block w-100" src={Slide3} alt="Slide 3" />
					</Carousel.Item>
					<Carousel.Item>
						<Image className="d-block w-100" src={Slide4} alt="Slide 4" />
					</Carousel.Item>
					<Carousel.Item>
						<Image className="d-block w-100" src={Slide5} alt="Slide 5" />
					</Carousel.Item>
					<Carousel.Item>
						<Image className="d-block w-100" src={Slide6} alt="Slide 6" />
					</Carousel.Item>
					<Carousel.Item>
						<Image className="d-block w-100" src={Slide7} alt="Slide 7" />
					</Carousel.Item>
					<Carousel.Item>
						<Image className="d-block w-100" src={Slide8} alt="Slide 8" />
					</Carousel.Item>
				</Carousel>
			</Row>
			<Row>
				<Col xl={3} lg={6} md={12} sm={12}>
					<StatRightIcon
						title="ELEVES"
						value={students.length}
						summary="Nombre d'élèves"
						iconName="users"
						iconColorVariant="primary"
						classValue="mb-4"
					/>
				</Col>

				<Col xl={3} lg={6} md={12} sm={12}>
					<StatRightIcon
						title="PERSONNEL"
						value={personnels.length}
						summary="Nombre d'employés"
						iconName="user-check"
						iconColorVariant="primary"
						classValue="mb-4"
					/>
				</Col>

				<Col xl={3} lg={6} md={12} sm={12}>
					<StatRightIcon
						title="COMPETENCES"
						value={competences.length}
						summary="Nombre de compétences"
						iconName="list-check"
						iconColorVariant="primary"
						classValue="mb-4"
					/>
				</Col>

				<Col xl={3} lg={6} md={12} sm={12}>
					<StatRightIcon
						title="MATIERES"
						value={matieres.length}
						summary="Nombre de matières"
						iconName="book"
						iconColorVariant="primary"
						classValue="mb-4"
					/>
				</Col>
			</Row>
		</div>
	);
};

export default Overview;
